import { Navigate } from 'react-router-dom';

const Logs = () => <Navigate to="/monitoring" replace />;

export default Logs;
